import qs from "qs";

export function paramsSerializerCommaFormat<T>(params: T): string {
  const stringifiedQuery = qs.stringify(params, { arrayFormat: "comma", encodeValuesOnly: true });
  return stringifiedQuery;
}

/**
 * Custom URL params serializer for axios 1.x.
 *
 * Axios 1.x no longer JSON-stringifies objects inside arrays — it calls
 * `.toString()` which produces `[object Object]`. This serializer restores
 * the 0.21.x behavior: objects in arrays are JSON-stringified, dates are
 * converted via `.toISOString()`, and null/undefined values are skipped.
 */
export function buildURLParams(params: Record<string | number, any>): string {
  const encode = (val: string) =>
    encodeURIComponent(val)
      .replace(/%3A/gi, ":")
      .replace(/%24/g, "$")
      .replace(/%2C/gi, ",")
      .replace(/%20/g, "+")
      .replace(/%5B/gi, "[")
      .replace(/%5D/gi, "]");

  const parts: string[] = [];
  Object.entries(params).forEach(([key, val]) => {
    if (val === null || typeof val === "undefined") return;

    const values = Array.isArray(val) ? val : [val];
    const encodedKey = Array.isArray(val) ? encode(key) + "[]" : encode(key);

    values.forEach((v) => {
      if (v instanceof Date) {
        v = v.toISOString();
      } else if (v !== null && typeof v === "object") {
        v = JSON.stringify(v);
      }
      parts.push(encodedKey + "=" + encode(String(v)));
    });
  });

  return parts.join("&");
}
